import ArrowRight20 from '@carbon/icons-react/es/arrow--right/20';
import { Col, Space } from 'antd';
import React, { FC } from 'react';
import { WithWizard } from 'react-albus';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { ClassNameOnlyProps } from 'components/ozone-component';
import { RoutePaths } from 'constant';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { Row } from './styled';

const StyledRow = styled(Row)`
  padding: var(--spacing-05);
  border-top: 1px solid var(--border-color);
`;

interface FooterProps extends ClassNameOnlyProps {
  handlers: { [stepName: string]: () => void };
  isSubmitting?: boolean;
  disableOkButton?: boolean;
  getNextStepId: (step, steps, canAccessFinancials) => string;
}

export const Footer: FC<FooterProps> = ({
  className,
  handlers,
  isSubmitting = false,
  getNextStepId,
}) => {
  const { search, hash } = useLocation();

  const [isFinancialsEnabled] = useAccountFeature(AccountFeature.Financials);
  const [accountability] = useAccountFeature(AccountFeature.Accountability);
  const canAccessFinancials = accountability && isFinancialsEnabled;

  return (
    <WithWizard
      render={({ step, steps, replace }) => (
        <StyledRow justify="space-between" className={className}>
          <Col span={6}>
            <Link
              to={{ pathname: RoutePaths.projects, search, hash }}
              data-cy="buttons.project-create-cancel"
            >
              <Button>
                <FormattedMessage id="cancel" />
              </Button>
            </Link>
          </Col>
          <Col>
            <Space size={16}>
              {steps.indexOf(step) > 0 && (
                <Button
                  onClick={() => {
                    const prevStepIndex = steps.indexOf(step) - 1;
                    const prevStep = steps[prevStepIndex];

                    replace(prevStep.id);
                  }}
                >
                  <FormattedMessage id="back" />
                </Button>
              )}
              <Button
                icon={<ArrowRight20 />}
                iconPlacement="right"
                type="primary"
                onClick={handlers[step.id]}
                loading={isSubmitting}
              >
                <FormattedMessage
                  id={getNextStepId(step, steps, canAccessFinancials)}
                />
              </Button>
            </Space>
          </Col>
        </StyledRow>
      )}
    />
  );
};
